import { render, staticRenderFns } from "./PlacementsSingle.vue?vue&type=template&id=995af256&"
import script from "./PlacementsSingle.vue?vue&type=script&lang=js&"
export * from "./PlacementsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports